import { Globe } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';

export const LanguageToggle = () => {
  const { i18n } = useTranslation();

  const toggleLocale = () => {
    i18n.changeLanguage(i18n.language === 'en' ? 'mn' : 'en');
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleLocale}
      className="gap-2 text-muted-foreground hover:text-foreground"
    >
      <Globe className="h-4 w-4" />
      <span className="font-medium">{i18n.language === 'en' ? 'MN' : 'EN'}</span>
    </Button>
  );
};
